import { ResponsiveImageSet } from './ResponsiveImage';

/**
 * Creates responsive image set for stat sections
 * @param src - Main image source
 * @param mobileSrc - Optional mobile image source
 * @returns Responsive image set
 */
export const createStatResponsiveImage = (src: string, mobileSrc?: string): ResponsiveImageSet => [
  {
    src: mobileSrc || src,
    size: { width: 767, aspectRatio: 559 / 300 },
    breakpoint: 767,
  },
  {
    src: mobileSrc || src,
    size: { width: 512, aspectRatio: 559 / 300 },
    breakpoint: 1023,
  },
  {
    src,
    size: { width: 600, aspectRatio: 559 / 300 },
    breakpoint: 1440,
  },
];

/**
 * Creates responsive image set for category carousel
 * @param src - Image source
 * @returns Responsive image set
 */
export const createCategoryCarouselImage = (src: string): ResponsiveImageSet => [
  {
    src,
    size: { width: 297, aspectRatio: 768 / 890 },
    breakpoint: 320,
  },
  {
    src,
    size: { width: 443, aspectRatio: 768 / 890 },
    breakpoint: 767,
  },
  {
    src,
    size: { width: 280, aspectRatio: 768 / 890 },
    breakpoint: 768,
  },
  {
    src,
    size: { width: 372, aspectRatio: 768 / 890 },
    breakpoint: 1023,
  },
  {
    src,
    size: { width: 262, aspectRatio: 768 / 890 },
    breakpoint: 1024,
  },
  {
    src,
    size: { width: 443, aspectRatio: 768 / 890 },
    breakpoint: 1440,
  },
];

/**
 * Creates responsive image set for content blocks with 558/240 aspect ratio
 * @param src - Main image source
 * @param mobileSrc - Optional mobile image source
 * @returns Responsive image set
 */
export const createContent1ResponsiveImage = (src: string, mobileSrc?: string): ResponsiveImageSet => [
  {
    src: mobileSrc || src,
    size: { width: 767, aspectRatio: 558 / 240 },
    breakpoint: 767,
  },
  {
    src: mobileSrc || src,
    size: { width: 1023, aspectRatio: 558 / 240 },
    breakpoint: 1023,
  },
  {
    src,
    size: { width: 600, aspectRatio: 558 / 240 },
    breakpoint: 1440,
  },
];

/**
 * Creates responsive image set for content blocks with 358/275 aspect ratio
 * @param src - Main image source
 * @param mobileSrc - Optional mobile image source
 * @returns Responsive image set
 */
export const createContent2ResponsiveImage = (src: string, mobileSrc?: string): ResponsiveImageSet => [
  {
    src: mobileSrc || src,
    size: { width: 767, aspectRatio: 358 / 275 },
    breakpoint: 767,
  },
  {
    src: mobileSrc || src,
    size: { width: 1023, aspectRatio: 358 / 275 },
    breakpoint: 1023,
  },
  {
    src,
    size: { width: 600, aspectRatio: 358 / 275 },
    breakpoint: 1440,
  },
];
